import React, { PureComponent } from 'react';
import { func, arrayOf } from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import {
  actionCreators as userFormActions,
  formResponsePropTypes
} from '../../../../../redux/userFormHandlers';
import { CLAIM } from '../../../../../constants/userForms';
import { EMPTY_STRING } from '../../../../../constants/common';
import { message } from '../../../../../utils/stringUtils';

import FormDetails from './components/FormDetails';
import styles from './styles';

class MobileProceduresContainer extends PureComponent {
  state = { formSelected: null };

  handleClick = form => {
    this.props.dispatch(userFormActions.getFormResponseDetails(form.id, form.account_id, form.form_type));
    this.setState({ formSelected: form });
  };

  handleReturn = () => this.setState({ formSelected: null });

  render() {
    return (
      <div style={styles.container}>
        {!this.state.formSelected ? (
          this.props.rows.map(form => (
            <UTTouchableWithoutFeedback
              key={form.id}
              style={styles.formRow}
              onClick={() => this.handleClick(form)}
            >
              <div style={styles.textContainer}>
                <UTLabel small>{form.form_name}</UTLabel>
                <UTLabel small ligth darkGray>
                  {`${message(
                    `${form.form_type === CLAIM ? 'Claims' : 'Procedures'}:formNumber`
                  )} ${form.external_id || EMPTY_STRING}`}
                </UTLabel>
              </div>
              <div style={styles.textContainer}>
                <UTLabel small ligth darkGray>
                  {form.started_at}
                </UTLabel>
                <UTLabel small ligth darkGray>
                  {form.status_label}
                </UTLabel>
              </div>
            </UTTouchableWithoutFeedback>
          ))
        ) : (
          <FormDetails
            form={this.state.formSelected}
            onReturn={this.handleReturn}
            handleOpenActionModal={this.props.handleOpenActionModal}
          />
        )}
      </div>
    );
  }
}

MobileProceduresContainer.propTypes = {
  handleOpenActionModal: func,
  rows: arrayOf(formResponsePropTypes)
};

export default connect()(Radium(MobileProceduresContainer));
